<template>
     <div>
         <header :class="['header', { 'header-index': title === 'inicio' } ]" :style="{ backgroundImage: image }">

             <navbar-header></navbar-header>

             <div class="menu-wrappper-mobile">
                 <div class="logo">
                     <img src="../../../../img/icons/png/ugt_logo.png" alt="UGT-SP" />
                 </div>

                <div class="menu-icon" @click="menuIsOpen = true">
                    <svg-icon icon="bars-solid"></svg-icon>
                </div>
            </div>

            <navbar-main :title="title" :breadcrumbs="breadcrumbs"></navbar-main>

        </header>

        <menu-mobile :menuIsOpen.sync="menuIsOpen"></menu-mobile>

    </div>
</template>

<script>
import navbarHeader from "./navbar-header.vue";
import navbarMain from "./navbar-main.vue";
import menuMobile from "./menu-mobile.vue";
import imagemMixin from "../../../mixins/images.mixin";
import { sample } from "lodash"

export default {
    name: "header-auth",
    mixins: [imagemMixin],
    components: { navbarHeader, navbarMain, menuMobile },

    data() {
        return {
            path: "",
            title: "",
            breadcrumbs: {
                category: "",
                subcategory: "",
            },
            menuIsOpen: false,
            image: '',
            images: [
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-001.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-002.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-003.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-004.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-005.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-006.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-007.png)',
                'linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(../../../../img/bg/bg-header-008.png)'
            ],

        };
    },

    methods: {
        changeBg() {
            this.image = sample(this.images);
        },

        changeTitle() {
            switch (this.path) {
                case "/":
                    return (this.title = "inicio");
                case "/noticias/noticias-ugt":
                    return (this.title = "UGT-SP Notícias");
                case "/noticias/palavra-do-presidente":
                    return (this.title = "Palavra do Presidente");
                case "/noticias/comentario-do-diretor":
                    return (this.title = "Comentário do Diretor");
                case "/institucional/carta-de-tupa":
                    return (this.title = "Carta de Tupã");
                case "/institucional/diretoria":
                    return (this.title = "Diretoria");
                case "/institucional/historia":
                    return (this.title = "História");
                case "/institucional/valores":
                    return (this.title = "Missão, Visão e Valores");
                case "/institucional/presidente":
                    return (this.title = "Presidente");
                case "/publicacoes":
                    return (this.title = "Publicações");
                case "/contato":
                    return (this.title = "Contato");
            }
        },

        changeBreadcrumbs() {
            switch (this.path) {
                case "/noticias/noticias-ugt":
                    return (this.breadcrumbs = {
                        category: "Notícias",
                        subcategory: "UGT-SP Notícias",
                    });
                case "/noticias/palavra-do-presidente":
                    return (this.breadcrumbs = {
                        category: "Notícias",
                        subcategory: "Palavra do Presidente",
                    });
                case "/noticias/comentario-do-diretor":
                    return (this.breadcrumbs = {
                        category: "Notícias",
                        subcategory: "Comentário do Diretor",
                    });
                case "/institucional/carta-de-tupa":
                    return (this.breadcrumbs = {
                        category: "Institucional",
                        subcategory: "Carta de Tupã",
                    });
                case "/institucional/diretoria":
                    return (this.breadcrumbs = {
                        category: "Institucional",
                        subcategory: "Diretoria",
                    });
                case "/institucional/historia":
                    return (this.breadcrumbs = {
                        category: "Institucional",
                        subcategory: "História",
                });
                case "/institucional/valores":
                    return (this.breadcrumbs = {
                        category: "Institucional",
                        subcategory: "Missão, Visão e Valores",
                    });
                case "/institucional/presidente":
                    return (this.breadcrumbs = {
                        category: "Institucional",
                        subcategory: "Presidente",
                    });
                case "/publicacoes":
                    return (this.breadcrumbs = {
                        category: "Publicações",
                        subcategory: "",
                    });
                case "/contato":
                    return (this.breadcrumbs = {
                        category: "Contato",
                        subcategory: "",
                    });
            }
        },
    },

    mounted() {
        this.path = this.$route.path;
        this.changeTitle();
        this.changeBreadcrumbs();
        this.changeBg();
    },
};

</script>

<style lang="scss" scoped>
    .header {

        height: 500px;


        a {
            @apply text-white;
        }

        @apply bg-black text-white;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;

        svg {
            width: 14px;
            height: 14px;
        }

        .menu-wrappper-mobile {
            @apply hidden;

            @media (max-width: 768px) {
                @apply flex justify-between items-center p-4;
            }

            & > .logo {
                width: 50px;
            }

            .menu-icon {
                svg {
                    width: 25px;
                    height: 25px;
                }
            }
        }
    }
</style>
